import { Badge } from '@/new/components/shadcn/badge';
import { cn } from '@/new/lib/utils';

export function SettingsHeader({
  title,
  subheading,
  action,
  hasUnsavedChanges = false,
  className,
}: {
  title: string;
  subheading: React.ReactNode;
  action?: React.ReactNode;
  hasUnsavedChanges?: boolean;
  className?: string;
}) {
  return (
    <div className={cn('mb-6', className)}>
      <div className="flex items-start justify-between gap-2">
        <div>
          <h2 className="text-base font-medium">{title}</h2>
          <div className="my-1 max-w-2xl text-sm text-gray-500">{subheading}</div>
        </div>

        <div className="flex items-center gap-4">
          {hasUnsavedChanges && (
            <Badge className="rounded-full border border-amber-300 bg-amber-100 px-3 py-1 text-xs font-medium text-amber-800">
              Unsaved changes
            </Badge>
          )}
          {action && action}
        </div>
      </div>
    </div>
  );
}
